module.exports = __webpack_public_path__ + "static/media/nus.f4f6f499.png";